/**
 * Return true if an annotation with the given permissions is private.
 */
export function isPrivate(perms) {
  return !perms.read.some(function (principal) {
    return principal.startsWith('group:');
  });
}
//# sourceMappingURL=permissions.js.map